import { COLOR_PRIMITIVES as a } from "./index.es703.js";
const r = {
  primary: {
    brand: {
      default: a.brand.base[80].default,
      hover: a.brand.base[90]
    },
    gray: {
      default: a.gray.base[80],
      hover: a.gray.base[100]
    },
    disabled: a.gray.base[50],
    white: a.neutral.white.default
  },
  text: {
    primary: a.gray.base[110],
    secondary: a.gray.base[90],
    gray: a.gray.base[70],
    disabled: a.gray.base[40],
    selection: a.brand.base[40]
  },
  icon: {
    default: a.gray.base[40],
    fillActive: a.brand.base[70],
    muted: a.brand.base[70],
    outline: a.gray.base[80],
    scrollbar: a.gray.base[60],
    gray: {
      default: a.gray.base[80],
      hover: a.gray.base[100]
    },
    brand: {
      default: a.brand.base[70],
      hover: a.brand.base[90]
    },
    disabled: a.gray.base[40],
    white: a.neutral.white.default,
    status: {
      error: a.red.base[40],
      success: a.green.base[70],
      warning: a.orange.base[60]
    },
    metric: {
      background: a.brand.base[20],
      brandFill: a.brand.base[40],
      whiteFill: a.neutral.white.default,
      outline: a.brand.base[80].default
    }
  },
  background: {
    hover: a.gray.base[20],
    hoverOnGray: a.gray.base[30],
    form: a.gray.base[10],
    system: a.brand.base[10].default
  },
  status: {
    error: {
      text: a.red.base[40],
      background: a.pink.base[5]
    },
    success: {
      text: a.green.base[70],
      background: a.green.base[5]
    },
    successHover: {
      text: a.green.base[75],
      background: a.green.base[5]
    },
    warning: {
      text: a.orange.base[60],
      background: a.orange.base[5]
    }
  },
  lines: {
    default: a.gray.base[30],
    section: a.gray.base[40],
    header: a.gray.base[90]
  },
  labels: {
    pink: {
      fill: a.pink.base[15],
      outline: a.pink.base[20]
    },
    blue: {
      fill: a.blue.base[5],
      outline: a.blue.base[20]
    },
    green: {
      fill: a.green.base[15],
      outline: a.green.base[20]
    },
    yellow: {
      fill: a.orange.base[15].default,
      outline: a.orange.base[20]
    },
    brown: {
      fill: a.brown.base[15],
      outline: a.brown.base[45]
    },
    gray: {
      fill: a.gray.base[10],
      outline: a.gray.base[30]
    }
  },
  grades: {
    APlus: a.green.base[60],
    A: a.green.base[50],
    B: a.orange.base[40],
    C: a.orange.base[50],
    D: a.red.base[10],
    E: a.red.base[20]
  },
  shadows: {
    popouts: a.neutral.black.opac15,
    sticky: a.neutral.black.opac10,
    backdrop: {
      100: a.neutral.black.opac45,
      200: "#0000004D",
      300: a.neutral.black.opac15,
      400: a.neutral.black.opac10,
      500: "#0000000D"
    },
    mapButtons: a.neutral.black.opac15,
    card: a.neutral.black.opac15
  },
  additionals: {
    fuchsia: a.pink.base[40],
    fillBackground: a.brand.base[30],
    customPOI: a.gray.base[60]
  },
  upsell: {
    labelBackground: a.brand.base[5]
  },
  contrast: {
    border: a.neutral.black.opac45
  },
  metricTier: [
    a.pink.base[40],
    a.orange.base[60],
    a.brand.base[80].default
  ]
};
export {
  r as BASE_DARK_THEME
};
//# sourceMappingURL=index.es5555.js.map
